class CategoryBlogGrid extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.addEventListener('click', this.handleClick);
    window.addEventListener('popstate', this.handlePopState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    window.removeEventListener('popstate', this.handlePopState);
  }

  handleClick = (event) => {
    const categoryLink = event.target.closest('[data-blog-category-link]');
    const loadMoreLink = event.target.closest('[data-blog-load-more]');

    if (!categoryLink && !loadMoreLink) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();

    if (categoryLink) {
      this.load(categoryLink.href, { append: false, updateHistory: true });
      return;
    }

    this.load(loadMoreLink.href, { append: true, updateHistory: false });
  };

  handlePopState = () => {
    this.load(window.location.href, { append: false, updateHistory: false });
  };

  async load(url, { append, updateHistory }) {
    if (this.getAttribute('aria-busy') === 'true') return;

    const requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set('section_id', this.dataset.sectionId);
    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) throw new Error(`Blog grid request failed: ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = documentFragment.querySelector('category-blog-grid');

      if (!nextSection) throw new Error('Blog grid section was not found in the response.');

      if (append) {
        this.appendPosts(nextSection);
      } else {
        this.replaceGrid(nextSection);

        if (updateHistory) {
          window.history.pushState({}, '', url);
        }
      }
    } catch (error) {
      window.location.assign(url);
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  appendPosts(nextSection) {
    const currentItems = this.querySelector('[data-blog-grid-items]');
    const nextItems = nextSection.querySelector('[data-blog-grid-items]');
    const currentActions = this.querySelector('[data-blog-grid-actions]');
    const nextActions = nextSection.querySelector('[data-blog-grid-actions]');

    if (!currentItems || !nextItems || !currentActions || !nextActions) return;

    const addedCount = nextItems.children.length;
    currentItems.append(...Array.from(nextItems.children));
    currentActions.replaceChildren(...Array.from(nextActions.children));
    this.announce(`${addedCount} more posts loaded.`);
  }

  replaceGrid(nextSection) {
    const currentCategories = this.querySelector('[data-blog-grid-categories]');
    const nextCategories = nextSection.querySelector('[data-blog-grid-categories]');
    const currentContent = this.querySelector('[data-blog-grid-content]');
    const nextContent = nextSection.querySelector('[data-blog-grid-content]');

    if (!currentCategories || !nextCategories || !currentContent || !nextContent) return;

    currentCategories.replaceChildren(...Array.from(nextCategories.children));
    currentContent.replaceChildren(...Array.from(nextContent.children));
    this.announce(`${this.querySelectorAll('.category-blog-card').length} posts displayed.`);
    this.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
  }

  announce(message) {
    const status = this.querySelector('[data-blog-grid-status]');
    if (status) status.textContent = message;
  }
}

if (!customElements.get('category-blog-grid')) {
  customElements.define('category-blog-grid', CategoryBlogGrid);
}
